/**
 * @generated SignedSource<<09cf05bd41f0bf2c86809c5ecbc426e5>>
 * @relayHash 2e0d23b02bb8039dc471290efffe68be
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6bf1e15578530e9fe17eabb096d09f176aa1443f8e8fb2f6bf62219a4ed0c970

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useAgentSessionsDataQuery$variables = {
  after?: string | null;
  aqlQuery: string;
  pageSize?: number | null;
  sharingContext: string;
  shouldReadSessions: boolean;
  sort?: string | null;
};
export type useAgentSessionsDataQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useAgentSessionsData_query">;
};
export type useAgentSessionsDataQuery = {
  response: useAgentSessionsDataQuery$data;
  variables: useAgentSessionsDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aqlQuery"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageSize"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sharingContext"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldReadSessions"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sort"
},
v6 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v7 = {
  "kind": "Variable",
  "name": "aqlQuery",
  "variableName": "aqlQuery"
},
v8 = {
  "kind": "Variable",
  "name": "sort",
  "variableName": "sort"
},
v9 = [
  (v6/*: any*/),
  (v7/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "pageSize"
  },
  {
    "kind": "Variable",
    "name": "shardingContext",
    "variableName": "sharingContext"
  },
  (v8/*: any*/)
],
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v12 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v13 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useAgentSessionsDataQuery",
    "selections": [
      {
        "args": [
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "kind": "Variable",
            "name": "pageSize",
            "variableName": "pageSize"
          },
          {
            "kind": "Variable",
            "name": "sharingContext",
            "variableName": "sharingContext"
          },
          {
            "kind": "Variable",
            "name": "shouldReadSessions",
            "variableName": "shouldReadSessions"
          },
          (v8/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "useAgentSessionsData_query"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "useAgentSessionsDataQuery",
    "selections": [
      {
        "condition": "shouldReadSessions",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v9/*: any*/),
            "concreteType": "AgentSessionConnection",
            "kind": "LinkedField",
            "name": "agent_sessionQuery",
            "plural": false,
            "selections": [
              {
                "concreteType": "AgentSessionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "AgentSession",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "state"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "stateReason"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "expireTime"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "lastStateChangeAt"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isRovo"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "agentAccountId"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "convoAiAgentId"
                      },
                      {
                        "kind": "LinkedField",
                        "name": "agent",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "picture"
                          },
                          (v10/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v10/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "studioAgent",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v13/*: any*/),
                          (v10/*: any*/)
                        ]
                      },
                      {
                        "alias": "conversationChannel",
                        "concreteType": "AgentConversationChannel",
                        "kind": "LinkedField",
                        "name": "nativeConversationChannel",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v13/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "lastAgentMessageStatus"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "readStatus"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isPlanning"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isPinned"
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "associatedEntities",
                        "plural": true,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "key"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "webUrl"
                              }
                            ],
                            "type": "JiraIssue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "title"
                              },
                              {
                                "concreteType": "ConfluencePageLinks",
                                "kind": "LinkedField",
                                "name": "links",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "base"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "webUi"
                                  }
                                ]
                              }
                            ],
                            "type": "ConfluencePage"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/)
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                          }
                        ]
                      },
                      (v11/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  }
                ]
              }
            ]
          },
          {
            "args": (v9/*: any*/),
            "filters": [
              "shardingContext",
              "aqlQuery",
              "sort"
            ],
            "handle": "connection",
            "key": "useAgentSessionsSnapshot_agent_sessionQuery",
            "kind": "LinkedHandle",
            "name": "agent_sessionQuery"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "6bf1e15578530e9fe17eabb096d09f176aa1443f8e8fb2f6bf62219a4ed0c970",
    "metadata": {},
    "name": "useAgentSessionsDataQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c3a88abf1987e37d8033263206c81222";

export default node;
